export const refrehOptionsRequest: string = "<<reset-requested>>";